<template>
<v-navigation-drawer v-model="$store.state.main.navigationDrawerOpened" :clipped="$vuetify.breakpoint.lgAndUp" fixed app>
    <v-list dense>
        <v-progress-linear :indeterminate="true" v-if="menuLoading"></v-progress-linear>
        <template v-for="item in items">
            <v-layout v-if="item.heading" :key="item.heading" row align-center>
                <v-flex xs6>
                    <v-subheader v-if="item.heading">
                        {{ item.heading }}
                    </v-subheader>
                </v-flex>
                <v-flex xs6 class="text-xs-center">
                    <a href="#!" class="body-2 black--text">EDIT</a>
                </v-flex>
            </v-layout>
            <v-list-group v-else-if="item.children" :key="item.text" v-model="item.model" :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="">
                <v-list-tile slot="activator">
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{ item.text }}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-for="(child, i) in item.children" :key="i" @click="">
                    <v-list-tile-action v-if="child.icon">
                        <v-icon>{{ child.icon }}</v-icon>*
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title @click="$router.push(child.link)"  >
                          <span :class="activeStatus(child.link)"> {{ child.text }}</span>
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list-group>
            <v-list-tile v-else :key="item.text" @click="gotoLink(item.link)">
                <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>
                        {{ item.text }}
                    </v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </template>
    </v-list>
</v-navigation-drawer>
</template>

<script>
import {
    HTTP
} from '../http-common'

export default {
    props: {
        drawer: Boolean
    },
    data: () => ({
        items: [],
        error: [],
        menuLoading: false,
        status: 0
    }),
    methods: {
        gotoLink: function (link) {
            this.$router.push({
                name: link
            })
        },
        activeStatus(s) {
            let status = 0
            if (this.$route.query && this.$route.query.status > 0) {
                status = this.$route.query.status
            }
             
            return s == '/?status='+ status || (status == 0 && s === '/') ? 'primary--text' : ''
        }
    },
    created() {
        this.menuLoading = true
        HTTP.get('/layout/menu')
            .then(response => {
                if (response.data.data && response.data.data.items) {
                    this.items = response.data.data.items

                }
            })
            .catch(e => {
                this.error.push(e)
            })
            .finally(
                () => {
                    this.menuLoading = false
                }
            )
    }
}
</script>
